import { useState, useCallback, useEffect, useRef } from 'react';
import axios from 'axios';
// import getApiToken from "../utils/getApiToken";
//
// const apiToken = getApiToken();

const useHttp = () => {
  const mounted = useRef(false);
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState(false);

  useEffect(() => {
    mounted.current = true; // Will set it to true on mount ...
    return () => { mounted.current = false; }; // ... and to false on unmount
  }, []);

  const CancelToken = axios.CancelToken;
  let source;

  const sendRequest = useCallback(async (config, applyData) => {
    // console.log('sendRequest');
    setIsLoading(true);
    setError(false);
    let data = null;
    // console.log('config', config);
    // var hdrs = location.hostname.includes('wbstudiotour') ?
    // 'application/json; charset=UTF-8' :
    // 'application/x-www-form-urlencoded; charset=UTF-8'
    let params = [];
    if (config.params) {
      // const serialized = serialize(config.params);
      // data_format = location.hostname.includes('wbstudiotour') ? serialized : config.params;
      for (let [key, value] of Object.entries(config.params)) {
        if (typeof value === 'object') value = JSON.stringify(value);
        params.push(`${key}=${value}`);
      }
      params = params.join('&');
    }
    // const data_format = location.hostname.includes('wbstudiotour') ? JSON.stringify(config.params) : config.params;
    // const data_format = location.hostname.includes('wbstudiotour') ? params : config.params;
    const data_format = params;
    // console.log('config.params', config.params);
    // console.log('params', params);
    if (source) source.cancel();
    source = CancelToken.source();
    // console.log('sendRequest url', url);
    try {
      const response = await axios({
        method: config.method ? config.method : 'post',
        url: config.url,
        data: config.params ? data_format : ''
      });
      data = await response.data;
      // console.log('data', data);
      if (applyData && data) data = applyData(data);
    } catch (error) {
      setError(error.message || 'Something went wrong!');
      if (!axios.isCancel(error)) {
        // console.warn(error);
        // console.warn(error.response);
      }
    }
    if (mounted.current) {
      setIsLoading(false);
    }
    return data;
  }, []);

  return {
    isLoading,
    error,
    sendRequest
  };
};

const serialize = (obj) => {
  let params = [];
  for (let [key, value] of Object.entries(obj)) {
    if (typeof value === 'object') value = JSON.stringify(value);
    params.push(`${key}=${value}`);
  }
  return params.join('&');
}

export default useHttp;
